import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { ExternalLink } from 'core/routing';
import { inWhitelabel } from 'core/whitelabel';

import { CopyrightStyled } from 'apps/components/footer/footer.styled';

const currentYear = new Date().getFullYear();

const Copyright = props => (
  <CopyrightStyled main={props.main}>
    {inWhitelabel() ? (
      <ExternalLink to='https://wikifactory.com'>
        <Trans>Powered by Wikifactory</Trans>
      </ExternalLink>
    ) : (
      <>© {currentYear} Wikifactory Ltd.</>
    )}
  </CopyrightStyled>
);

Copyright.propTypes = {
  main: PropTypes.bool,
};

export default withNamespaces()(Copyright);
